<template>
  <div id="app" class="div-block-6">
    <header>
      <router-link to="/">
        <h1 class="site-title">Bismarck</h1>
      </router-link>
      <nav class="site-nav">
        <div class="nav-item">
          <router-link to="/leadership" class="nav-item-link"
            >Leadership</router-link
          >
        </div>
        <div class="nav-item">
          <router-link to="/brief" class="nav-item-link">Brief</router-link>
        </div>
        <div class="nav-item">
          <router-link to="/analysis" class="nav-item-link"
            >Analysis</router-link
          >
        </div>
        <div class="nav-item">
          <router-link to="/inquire" class="nav-item-link">Inquire</router-link>
        </div>
      </nav>
    </header>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  computed: {
    currentRoute() {
      return window.location.pathname;
    },
  },
  mounted() {
    const preloadUrls = [
      "/images/Resized-Samo.jpg",
      "/images/Resized-Ben.jpg",
      "/images/machine-tools.jpeg",
      "/images/bomb1.jpg",
      "/images/samo-signature-white.png",
      "/images/JFK_Chep_Morrison_Oval_Office_1961_Reading_Color.jpeg",
    ];
    preloadUrls.forEach((url) => {
      const img = new Image();
      img.src = url;
    });
  },
};
</script>

<style>
div#app {
  padding-right: 25px;
  padding-left: 25px;
}
.div-block-6 {
  padding: 15px;
}
header {
  z-index: 10;
  min-width: calc(100%);
  width: min(1200px, 100%);
  margin-right: auto;
  margin-left: auto;
  display: block;
  padding-top: 1.5em;
  padding-bottom: 2em;
}

div#app {
  min-width: 300px;
}
@media screen and (max-width: 320px) {
  div#app {
    padding-left: 20px;
    padding-right: 20px;
  }
}
@media screen and (min-width: 600px) {
  div#app {
    width: 550px;
  }
}
@media screen and (min-width: 700px) {
  div#app {
    width: 650px;
  }
}
@media screen and (min-width: 800px) {
  div#app {
    width: 750px;
  }
}
@media screen and (min-width: 900px) {
  div#app {
    width: 850px;
  }
}
@media screen and (min-width: 1000px) {
  div#app {
    width: 950px;
  }
}
@media screen and (min-width: 1100px) {
  div#app {
    width: 1050px;
  }
}
@media screen and (min-width: 1200px) {
  div#app {
    width: 1150px;
  }
}

.site-title,
.site-title:visited {
  float: left;
  display: block;
  font-family: "Big caslon", "Libre Caslon Text", "Times New Roman", Times,
    serif;
  color: #fff;
  font-size: 30pt;
  font-weight: 400;
  font-kerning: normal;
  text-transform: uppercase;
}

nav {
  float: right;
  line-height: 100px;
  display: block;
  font-family: "Roboto", Helvetica, sans-serif;
}
.nav-item {
  display: inline;
  margin: 20px;
  margin-right: 10px;
  margin-top: 10px;
}
.nav-item-link {
  padding-bottom: 5px;
  font-family: "Roboto", Helvetica, sans-serif;
  color: #fff;
  font-size: 16px;
  font-weight: 400;
  text-decoration: none;
}

.site-title,
.site-title:visited,
.nav-item-link:hover,
.nav-item-link.router-link-exact-active {
  border-bottom: 1px solid #aaa;
}

@media screen and (max-width: 699px) {
  nav {
    float: left;
    line-height: 150px; /* = 100 + (BRIEF_HEADER_SPACE_MID := 50) */
  }
  .nav-item:first-child {
    margin-left: 0px;
  }
}
@media screen and (max-width: 390px) {
  nav {
    line-height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    clear: both;
    margin-top: 58px; /* = (BRIEF_HEADER_SPACE_SMALL := 58) */
    margin-bottom: 24px;
  }
  .nav-item {
    display: inline-block;
    height: 24px;
    margin-left: 0px;
    flex: none;
    margin-bottom: 4px;
  }
}

h2 {
  font-family: "Libre Caslon Text", "Times New Roman", Times, serif;
  color: #fff;
  font-size: 24pt;
  font-weight: 400;
  line-height: 34pt;
}

h3 {
  font-family: "Libre Caslon Text", "Times New Roman", Times, serif;
  color: #fff;
  font-size: 16pt;
  font-weight: 700;
  line-height: 22pt;
}

h4 {
  font-family: "Libre Caslon Text", "Times New Roman", Times, serif;
  color: #fff;
  font-size: 16pt;
  font-weight: 400;
  line-height: 22pt;
}

p {
  font-family: "Roboto", Helvetica, sans-serif;
  font-weight: 400;
  font-size: 12pt;
  line-height: 17pt;
}
p,
a {
  color: #ddd;
}
</style>
